import { Close, Search } from '@mui/icons-material';
import {
	DialogContent,
	DialogTitle,
	Divider,
	IconButton,
	InputAdornment,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import React, { useState } from 'react';
import SidePanelDialog from 'src/globalComponents/SidePanelDialog';
import OptionsCards from './OptionsCards';
import AccessoryCard from './AccessoryCard';
import Accessory from 'src/types/shared/accessory';

const AccessorySelection: React.FC<{
	key: any;
	isOpen: boolean;
	onClose: () => void;
	optionIndex: number | null;
	accessories: Accessory[];
}> = ({ key, isOpen, onClose, optionIndex, accessories }) => {
	const [selectedOptions, setSelectedOptions] = useState<number[]>(
		optionIndex != null ? [optionIndex] : []
	);
	const [searchInput, setSearchInput] = useState('');

	const filteredAccessories = accessories.filter(
		(accessory) =>
			accessory.name.toLowerCase().includes(searchInput.toLowerCase()) ||
			accessory.description
				?.toLowerCase()
				?.includes(searchInput.toLowerCase()) ||
			accessory.materials
				.map((mat) => mat.name)
				.join(' ')
				.toLowerCase()
				.includes(searchInput.toLowerCase())
	);

	return (
		<SidePanelDialog
			key={key}
			open={isOpen}
			onClose={onClose}
			keepMounted={false}
			closeAfterTransition={true}
		>
			<DialogTitle
				sx={{
					padding: '0px',
				}}
			>
				<Stack
					sx={{
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
						padding: '0px',
					}}
				>
					<Stack>
						<Typography fontWeight="bold">Add Accessory</Typography>
						<Typography fontSize="13px" color="gray.500">
							Select option, then choose accessories to add
						</Typography>
					</Stack>

					<IconButton onClick={onClose}>
						<Close />
					</IconButton>
				</Stack>

				<Divider sx={{ marginY: '15px' }} />

				<OptionsCards
					selectedOptions={selectedOptions}
					setSelectedOptions={setSelectedOptions}
				/>

				<TextField
					sx={{
						width: '100%',
						marginY: '10px',
					}}
					aria-label="Search"
					placeholder="Search accessories..."
					size="small"
					variant="outlined"
					value={searchInput}
					onChange={(e) => {
						setSearchInput(e.target.value);
					}}
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment
									position="start"
									sx={{
										marginLeft: '-10px',
									}}
								>
									<Search fontSize="small" />
								</InputAdornment>
							),
							endAdornment: (
								<InputAdornment
									position="start"
									sx={{
										marginRight: '-10px',
									}}
								>
									<IconButton onClick={() => setSearchInput('')}>
										<Close fontSize="small" />
									</IconButton>
								</InputAdornment>
							),
						},
					}}
				/>
			</DialogTitle>

			<DialogContent
				sx={{
					padding: '0px',
					paddingTop: '20px',
				}}
			>
				<Stack sx={{ gap: '10px' }}>
					{filteredAccessories.map((accessory, index) => (
						<AccessoryCard
							key={index}
							accessory={accessory}
							selectedOptions={selectedOptions}
						/>
					))}
				</Stack>
			</DialogContent>
		</SidePanelDialog>
	);
};

export default AccessorySelection;
